import { displayOnHover } from 'src/theme';
import { stepSeparatorHeightPx } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

export const useActionRowStyles = makeStyles()(theme => ({
  actionRow: {
    // Controls showing/hiding DeleteActionsButton.
    [`&:hover .${displayOnHover}`]: {
      opacity: 1,
      pointerEvents: 'auto',
    },
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: 3,
    boxSizing: 'border-box',
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 2),
  },
}));

interface StyleProps {
  isActiveStep: boolean;
  isNumberedSection: boolean;
  isStepComplete: boolean;
}

export const useTimelineStyles = makeStyles()(() => ({
  timeline: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const useTimelineItemStyles = makeStyles<StyleProps>()(
  (theme, { isActiveStep, isStepComplete }) => ({
    currentStep: {
      marginTop: -stepSeparatorHeightPx,
    },
    timelineConnector: {
      backgroundColor:
        isActiveStep || isStepComplete ? theme.palette.primary.main : theme.appColors.rule,
      width: 1,
    },
    timelineContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    timelineItem: {
      display: 'flex',
      flexWrap: 'nowrap',
    },
    timelineSeparator: {
      height: '100%',
    },
  })
);
